var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ods-main-navigation',{ref:"navigation",attrs:{"navigation":_vm.navigation}},[_c('template',{slot:"suites"},[_c('suites-menu')],1),_c('template',{slot:"isPhone-user-menu"},[_c('user-menu',{staticClass:"is-phone__user-menu"})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28cb8c84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/NavContent.vue
// module id = null
// module chunks = 